import axios from 'axios/index';
export const BaseUrl = '/api/';
import router from '../router';


/**
 * Create axios wrapper instance
 *
 * @type {AxiosInstance}
 */
export const HTTP = axios.create({
    baseURL: BaseUrl
});

HTTP.interceptors.request.use(function (config) {
    if(!window.localStorage.getItem('token') && router.currentRoute.path !== '/login') {
        router.push('/login')
    }
    config.headers.common['Authorization'] = "Bearer " + window.localStorage.getItem('token');
    return config;
});

HTTP.interceptors.response.use(function (response) {
    return response.data;
}, function (error) {
    // Do something with response error
    return error.response;
});



